module.exports = __webpack_public_path__ + "static/media/VestasSans-Medium.85b2885b.eot";